
function convertNumberToReal(number) {
    const n = 2; // Quantidade de decimais
    const x = 3;
    const s = ".";
    const c = ",";

    const re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")",
        num = number.toFixed(Math.max(0, ~~n));

    return (
        "R$ " +
        (c ? num.replace(".", c) : num).replace(
            new RegExp(re, "g"),
            "$&" + (s || ",")
        )
    );
}

function convertRealToFloat(number) {
    if (typeof number == "string") {
        return parseFloat(number.replace("R$", "").replace(".", "").replace(",", "."));
    }
    return 0;
}

export { convertNumberToReal, convertRealToFloat }